export default __webpack_public_path__ + "static/media/imagem_404.30cc6602.png";